import CryptoJS from "crypto-js";

const key: string = process.env.REACT_APP_PASSWORD_KEY!;
const iv: string = process.env.REACT_APP_IV!;

// 암호화
export const aesEncrypt = (data: string) => {
  const cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return cipher.toString(); // base64
};

// 복호화
export const aesDecrypt = (encrypted: string) => {
  const bytes = CryptoJS.AES.decrypt(encrypted, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return bytes.toString(CryptoJS.enc.Utf8);
};
